import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { GuestGuard, RegistrationComplete, AuthGuard } from "../../guards";
import { ROUTES_CONFIG } from "../../config";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { BankDetailsComponent } from "./bank-details/bank-details.component";
import { MyAuctionsComponent } from "./my-auctions/my-auctions.component";
import { FavoritesComponent } from "./favorites/favorites.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { TransactionHistoryComponent } from "./transaction-history/transaction-history.component";
import { PersonalInformationComponent } from "./personal-information/personal-information.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: ROUTES_CONFIG.PROFILE_PERSONAL_INFORMATION.ROUTE,
    pathMatch: "full",
  }, // redirect to `first-component`
  {
    path: ROUTES_CONFIG.PROFILE_PERSONAL_INFORMATION.ROUTE,
    component: PersonalInformationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ROUTES_CONFIG.PROFILE_CHANGE_PASSWORD.ROUTE,
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: ROUTES_CONFIG.PROFILE_BANK_DETAILS.ROUTE,
  //   component: BankDetailsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: ROUTES_CONFIG.PROFILE_MY_AUCTIONS.ROUTE,
    component: MyAuctionsComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: ROUTES_CONFIG.PROFILE_FAVORITES.ROUTE,
  //   component: FavoritesComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: ROUTES_CONFIG.PROFILE_NOTIFICATIONS.ROUTE,
  //   component: NotificationsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: ROUTES_CONFIG.PROFILE_TRANSACTION_HISTORY.ROUTE,
    component: TransactionHistoryComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRouting {}
